<style lang="scss" scoped>
@use '~@/styles/main';
@use '~@/styles/base/variables';

.ml-auto {
  margin-left: auto;
}

.wrapper {
  position: relative;
  display: flex;

  &.no-relative {
    position: unset;

    .symbols {
      top: 50px !important;
    }
  }
}

.button {
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  color: var(--color-text-light);
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  width: 100%;

  &.select-style {
    min-width: 202px;
    border-radius: 4px;
    border: 1px solid var(--color-input);
    height: 32px;
    padding: 8px;
    transition: border-color 300ms;

    &:hover {
      border-color: var(--color-text-light);
    }

    &:focus {
      border-color: var(--color-text-light);
    }

    &_active {
      border-color: var(--color-text-light);
      box-shadow: 0 0 0 2px #ffffff40;
    }

    & + .symbols {
      top: 36px !important;
    }
  }

  &.error {
    border-color:var(--color-danger-light);
  }

  &:disabled {
    border-color: var(--color-input) !important;
    box-shadow: unset !important;
    cursor: default;
  }
}

.arrow {
  fill: var(--color-text);
  transform: rotate(0deg);
  transition: all 0.3s;

  &_active {
    transform: rotate(180deg);
  }
}

.symbols {
  position: absolute;
  top: 30px;
  left: -96px;
  width: 420px;
  z-index: 2000;
  box-shadow: 0 0 15px var(--color-input);
  border-radius: 5px;

  ::v-deep .box {
    background-color: var(--color-background);
  }

  @media screen and (max-width: variables.$standart) {
    width: 340px;
    left: -80px;
  }

  @media screen and (max-width: variables.$medium) {
    left: -100px;
  }

  @media screen and (max-width: variables.$small) {
    left: -78px;
  }

  &.bots {
    @media screen and (max-width: variables.$xs) {
      left: -10px;
    }
  }
}
</style>

<template>
  <div
    class="wrapper"
    :class="{'no-relative': noRelative}"
  >
    <button
      :id="buttonId"
      @click="focusSymbols()"
      class="button noselect"
      :class="{ 'select-style': selectStyle, 'select-style_active': selectStyle && showSymbols, error }"
      :disabled="disabled"
      :title="title"
    >
      <CoinIcon :symbol="symbol" />
      <span>{{ symbol }}</span>
      <Icon
        v-if="selectStyle"
        type="ios-arrow-down"
        size="14"
        class="arrow ml-auto"
        :class="{'arrow_active': showSymbols}"
      ></Icon>
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        class="arrow"
        :class="{'arrow_active': showSymbols}"
        viewBox="0 0 24 24"
      >
        <path d="M16 9v2l-4 4.24L8 11V9h8z"></path>
      </svg>
    </button>
    <transition name="fade">
      <Symbols
        :id="symbolsId"
        class="symbols"
        :class="{'bots': botsStyle}"
        :show="showSymbols"
        @selectSymbol="selectSymbol"
        :symbol="symbol"
        :extraSymbols="symbols"
        :noFav="noFav"
      />
    </transition>
  </div>
</template>

<script>
import Symbols from '@/components/MainPage/Terminal/Symbols'
import CoinIcon from '@/components/common/CoinIcon'

export default {
  props: {
    value: String,
    disabled: Boolean,
    selectStyle: Boolean,
    error: Boolean,
    noRelative: Boolean,
    noFav: Boolean,
    botsStyle: Boolean,
    symbols: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Symbols,
    CoinIcon
  },
  data () {
    return {
      showSymbols: false
    }
  },
  computed: {
    symbol: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    isSymbolNotFound () {
      const symbol = this.symbol.split('/')
      const baseAsset = symbol[0]
      const quoteAsset = symbol[1]

      return (
        this.symbols.length &&
        this.symbols.findIndex(
          item => item.baseAsset === baseAsset && item.quoteAsset === quoteAsset
        ) === -1
      )
    },
    title () {
      return this.isSymbolNotFound ? this.$text.tr('Пара не найдена') : ''
    },
    buttonId () {
      return 'symbols-chooser-button_' + Math.random()
    },
    symbolsId () {
      return 'symbols-chooser-symbols_' + Math.random()
    }
  },
  watch: {
    isSymbolNotFound: function (value) {
      this.$emit('update:error', value)
    }
  },
  methods: {
    selectSymbol (value, showSymbols = false) {
      this.showSymbols = showSymbols
      this.symbol = value
      this.$emit('click', value)
    },
    focusSymbols () {
      if (this.disabled) {
        return
      }

      this.showSymbols = !this.showSymbols
      this.$nextTick(() => {
        document.addEventListener('click', this.hideSymbolsComponent)
      })
    },
    hideSymbolsComponent (e) {
      const symbols = document.getElementById(this.symbolsId)
      const button = document.getElementById(this.buttonId)

      if (
        e.target &&
        e.target.parentNode &&
        !(symbols && symbols.contains(e.target)) &&
        !(button && button.contains(e.target))
      ) {
        this.showSymbols = false
        document.removeEventListener('click', this.hideSymbolsComponent)
      }
    }
  }
}
</script>
